import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

const { Types, Creators } = createActions({
  getUserProfile: [],
  clearStatus: [],
  updatePassword: ['newPassword', 'oldPassword'],
  updatePasswordSuccess: [],
  updatePasswordFailure: ['errorData'],
  recoverUserPassword: ['email'],
  recoverUserPasswordStatus: ['emailSent'],
  updateProfile: ['userData'],
  setUserProfile: ['userData'],
  updateProfileFailure: ['errorData'],
  setStatus: [],
  updateAvatar: ['avatar'],
  removeAvatar: ['fileName'],
  getUserFirstAccess: [],
  setFirstAccess: ['firstAccess'],
  updateFirstAccess: ['firstAccess'],
  saveFirstAccessLog: ['firstAccess'],
  canUserResetPassword: ['token'],
  resetUserPassword: ['credentials'],
  userProfileUpdate: ['data'],
  forceOpenWelcomeModal: [],
  forceFirstAccess: [],
  getAccessProfiles: [],
  setAccessProfiles: ['accessProfiles'],
  resetUserProfile: [],
});

export const UserProfileTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  name: '',
  email: '',
  avatar: '',
  status: {},
  firstAccess: {
    show: null,
    htmlMessage: '',
  },
  emailSent: null,
  accessProfiles: {
    loaded: null,
    list: null,
  },
});

// Reducers
const setUserProfile = (state = INITIAL_STATE, action) => {
  const { name, email, avatar, userId } = action.userData;
  return {
    ...state,
    userId,
    name,
    email,
    avatar: avatar || '',
  };
};

const refreshProfile = (state = INITIAL_STATE, action) => {
  const { name, avatar } = action.userData;
  return {
    ...state,
    name,
    avatar: avatar || '',
    status: {
      msg: 'Perfil atualizado com sucesso!',
      variant: 'success',
    },
  };
};

const updateProfileFailure = (state = INITIAL_STATE) => ({
  ...state,
  status: {
    msg: 'Erro ao atualizar perfil. Tente novamente mais tarde!',
    variant: 'error',
  },
});

const updatePasswordSuccess = (state = INITIAL_STATE) => ({
  ...state,
  status: {
    msg: 'Senha atualizada com sucesso!',
    variant: 'success',
  },
});

const updatePasswordFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  status: {
    msg: action.errorData.message,
    variant: 'error',
  },
});

const setStatus = (state = INITIAL_STATE) => ({ ...state, status: {} });

const setFirstAccess = (state = INITIAL_STATE, { firstAccess }) => ({
  ...state,
  firstAccess,
});

const updateFirstAccess = (state = INITIAL_STATE, { firstAccess }) => ({
  ...state,
  firstAccess: {
    ...state.firstAccess,
    ...firstAccess,
  },
});

const handleRecoverUserPassword = (state = INITIAL_STATE, { emailSent }) => ({
  ...state,
  emailSent,
});

const userProfileUpdate = (state = INITIAL_STATE, { data }) => ({
  ...state,
  ...data,
});

const forceFakeFirstAccess = (state = INITIAL_STATE) => ({
  ...state,
  firstAccess: {
    ...state.firstAccess,
    show: true,
  },
});

const setAccessProfiles = (state = INITIAL_STATE, { accessProfiles }) => ({
  ...state,
  accessProfiles,
});

const resetUserProfile = () => ({ ...INITIAL_STATE });

/* Reducers to types */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_USER_PROFILE]: setUserProfile,
  [Types.UPDATE_PROFILE]: refreshProfile,
  [Types.UPDATE_PROFILE_FAILURE]: updateProfileFailure,
  [Types.SET_STATUS]: setStatus,
  [Types.UPDATE_PASSWORD_SUCCESS]: updatePasswordSuccess,
  [Types.UPDATE_PASSWORD_FAILURE]: updatePasswordFailure,
  [Types.SET_FIRST_ACCESS]: setFirstAccess,
  [Types.UPDATE_FIRST_ACCESS]: updateFirstAccess,
  [Types.RECOVER_USER_PASSWORD_STATUS]: handleRecoverUserPassword,
  [Types.USER_PROFILE_UPDATE]: userProfileUpdate,
  [Types.FORCE_FIRST_ACCESS]: forceFakeFirstAccess,
  [Types.SET_ACCESS_PROFILES]: setAccessProfiles,
  [Types.RESET_USER_PROFILE]: resetUserProfile,
});
